import { type Control, Controller, type UseFormSetValue } from 'react-hook-form'

import { DateInput } from '@/components/ui/DateInput'
import { FieldError } from '@/components/ui/field-error'
import { TimePicker } from '@/components/ui/time-picker'
import { AddressFields } from '../../../../components/AddressFields'
import type { Step3FormValues } from './claimStep3Values'

interface ClaimWhenWhereSectionProps {
  control: Control<Step3FormValues>
  setValue: UseFormSetValue<Step3FormValues>
}

export function ClaimWhenWhereSection({ control, setValue }: ClaimWhenWhereSectionProps) {
  return (
    <>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Controller
          name="date"
          control={control}
          rules={{ validate: (v) => !!v || 'Date is required.' }}
          render={({ field, fieldState }) => (
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-neutral-700">Date of incident *</label>
              <DateInput
                label="MM/DD/YYYY"
                value={field.value ?? undefined}
                onChange={(d) => field.onChange(d ?? null)}
                inputProps={{ 'aria-invalid': fieldState.error ? true : undefined }}
              />
              <FieldError message={fieldState.error?.message} />
            </div>
          )}
        />
        <Controller
          name="time"
          control={control}
          render={({ field }) => (
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-neutral-700" htmlFor="claim-incident-time">
                Time of incident
              </label>
              <TimePicker
                id="claim-incident-time"
                value={field.value}
                onChange={field.onChange}
                onClear={() => field.onChange(null)}
              />
              <p className="text-xs text-neutral-500">
                Leave blank if you&apos;re not sure — it can be added later.
              </p>
            </div>
          )}
        />
      </div>

      <div className="flex flex-col gap-1">
        <AddressFields
          control={control}
          setValue={setValue}
          names={{ line1: 'location', city: 'city', state: 'state' }}
          label="Location *"
          required
        />
        <p className="text-xs text-neutral-500">
          Not at a street address? Describe the road instead, e.g. &quot;I-99 SB Mile Marker 247&quot; or
          &quot;Hwy 101 near exit 42&quot;.
        </p>
      </div>
    </>
  )
}
